var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcLiveStream(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "25px",
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icLiveStream") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Menu-Premium-16-chracterss",
    transform: "translate(-17.000000, -496.000000)",
    fill: "#333333",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-15",
    transform: "translate(-45.000000, 145.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-16"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-19",
    transform: "translate(43.000000, 280.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy-11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-17"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(14.000000, 64.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "play-button-(1)",
    transform: "translate(5.000000, 7.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5,0 C19.3929199,0 25,5.60761719 25,12.5 C25,19.3923828 19.3929199,25 12.5,25 C5.60708008,25 0,19.3923828 0,12.5 C0,5.60761719 5.60708008,0 12.5,0 Z M12.5,1.04165039 C6.18183594,1.04165039 1.04165039,6.18183594 1.04165039,12.5 C1.04165039,18.8181641 6.18183594,23.9583496 12.5,23.9583496 C18.8181641,23.9583496 23.9583496,18.8181641 23.9583496,12.5 C23.9583496,6.18183594 18.8181641,1.04165039 12.5,1.04165039 Z M9.64663086,7.35522461 C9.81142578,7.26469727 10.0179199,7.2703125 10.1776367,7.37456055 L10.1776367,7.37456055 L17.4692871,12.0620605 C17.6178223,12.1577148 17.7083496,12.322998 17.7083496,12.5 C17.7083496,12.677002 17.6178223,12.842334 17.4692871,12.9379395 L17.4692871,12.9379395 L10.1776367,17.6254395 C10.0921875,17.6808594 9.99350586,17.7083496 9.89584961,17.7083496 C9.81040039,17.7083496 9.72392578,17.6870117 9.64663086,17.6447754 C9.47875977,17.5532227 9.375,17.3782227 9.375,17.1875 L9.375,17.1875 L9.375,7.8125 C9.375,7.62177734 9.47875977,7.44677734 9.64663086,7.35522461 Z M10.4166504,8.76669922 L10.4166504,16.2333008 L16.2241699,12.5 L10.4166504,8.76669922 Z",
    id: "icLiveStream"
  })))))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLiveStream);
export default __webpack_public_path__ + "static/media/icLiveStream.52acba1872542e21e9fc781ba3d91da2.svg";
export { ForwardRef as ReactComponent };